// extracted by mini-css-extract-plugin
export var inactiveLogo = "styles-module--inactiveLogo--ra67I";
export var companyLogosWrapper = "styles-module--companyLogosWrapper--rV5L7";
export var companyLogosSlider = "styles-module--companyLogosSlider--JPrEU";
export var individualLogoWrapper = "styles-module--individualLogoWrapper--LZFGe";
export var arrowWrapper = "styles-module--arrowWrapper--+KkNk";